import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Autocomplete, Box, Chip, TextField } from "@mui/material";
import { useCreateCampaignTaskMutation } from "../../../Services/campign/CampaignDetail";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ReactQuill from "react-quill";
import { useUsersByTeamIdQuery } from "../../../Services/ticket/users/UsersByTeamId";
import { useGetSearchByEmailQuery } from "../../../Services/email/EmailTemplate";

interface IPROPS {
  taskInfo: any;
  close: any;

}
const CreateTask: React.FC<IPROPS> = ({
  taskInfo,
  close
}) => {
  const [createTaskInfo, setCreateTaskInfo] = useState<{
    subject: string;
    attachments: { file_name: string; file: string }[];
    date: string;
    eventDate: string;
    EventDescription: string;
    Lead: string;
    reminderTime: string;
    StartTime: string;
    status: string;
    guests: any;
  }>({
    subject: "",
    date: "",
    eventDate: "",
    EventDescription: "",
    Lead: "",
    reminderTime: "",
    StartTime: "",
    status: "",
    attachments: [],
    guests: [],
  });

  const [haveValues, setHaveValues] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const [createTask] = useCreateCampaignTaskMutation({});
  const [clicked, setClicked] = useState(false);
  const [checkBoxSelected, setCheckboxSelected] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [users, setUsers] = useState([]);
  const [files, setFiles] = useState([]);
  const [queryParam, setQueryParam] = useState();
  const [emailOptions, setEmailOptions] = useState<any[]>([]);
  const [timeSlots, setTimeSlots] = useState<string[]>([]);

  const selectedTeam = localStorage.getItem("teamId");
  const getUserID = localStorage.getItem("User_Id");

  const getUserRole = localStorage.getItem("user_role");

  const currentUser = localStorage.getItem("circleone-username");

  const { data } = useGetSearchByEmailQuery(queryParam, {
    skip: !queryParam,
  });

  const { data: usersData } = useUsersByTeamIdQuery(
    selectedTeam,
    {
      skip: !selectedTeam,
    }
  );

  useEffect(() => {
    if (usersData) {
      setUsers(usersData);

      // Find the user whose ID matches getUserID
      const matchedUser = usersData.find(
        (user) => String(user.id) === getUserID
      );

      // If a match is found, set it as the selected user
      if (matchedUser) {
        setSelectedUser(matchedUser.id);
      }
    }
  }, [usersData, getUserID]);

  const extractEmailOptions = (data: any) => {
    if (!data) return [];
    return data.map((item) => ({ label: item.email }));
  };

  useEffect(() => {
    if (data) {
      setEmailOptions(extractEmailOptions(data));
    }
  }, [data]);

  const handleSelectChange = (e) => {
    setSelectedUser(e.target.value);
  };

  const StatusArry = [
    { label: "Active", id: "active" },
    { label: "Re-Scheduled", id: "rescheduled" },
    { label: "Cancelled", id: "cancelled" },
    { label: "Done", id: "done" },
  ];

  const convertTo24Hour = (time: string): string => {
    const match = time.trim().match(/^(\d{1,2}):(\d{2})\s?(AM|PM)?$/i);
    if (!match) return time; // Return as is if no match

    let [, hour, minute, period] = match;
    let hr = parseInt(hour, 10);

    if (period) {
      period = period.toUpperCase();
      if (period === "PM" && hr !== 12) hr += 12;
      if (period === "AM" && hr === 12) hr = 0;
    }

    return `${hr.toString().padStart(2, "0")}:${minute}`;
  };

  const convertTo12Hour = (time: string): string => {
    const match = time.trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return time; // Return as is if no match

    let [_, hour, minute] = match;
    let hr = parseInt(hour, 10);
    const period = hr >= 12 ? "PM" : "AM";

    hr = hr % 12 || 12; // Convert 0 to 12 AM

    return `${hr}:${minute} ${period}`;
  };

  const generateTimeSlots = (selectedDate?: string): string[] => {
    const now = dayjs();
    const isToday = selectedDate && dayjs(selectedDate).isSame(now, "day");
    const times: string[] = [];

    for (let hour = 0; hour < 24; hour++) {
      for (let min of ["00", "30"]) {
        const slotTime = dayjs().hour(hour).minute(parseInt(min));
        if (isToday && slotTime.isBefore(now, "minute")) continue;

        const ampm = hour < 12 ? "AM" : "PM";
        const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
        times.push(`${formattedHour}:${min} ${ampm}`);
      }
    }

    return times;
  };

  // Generate time slots

  useEffect(() => {
    setTimeSlots(generateTimeSlots(createTaskInfo.date));
  }, [createTaskInfo.date]);

  const reminderTimeArry = [
    { label: "5 minutes ", id: "00:05:00" },
    { label: "15 minutes ", id: "00:15:00" },
    { label: "30 minutes ", id: "00:30:00" },
    { label: "60 minutes ", id: "01:00:00" },
  ];

  console.log(createTaskInfo, "createTaskInfo");

  const deleteImageHandler = (index: number) => {
    setCreateTaskInfo((prevState) => {
      const updatedAttachments = prevState.attachments.filter(
        (_, i) => i !== index
      );

      // Update `haveValues` with the new list of file names
      const updatedFileNames = updatedAttachments
        .map((file) => file.file_name)
        .join(", ");
      setHaveValues(updatedFileNames);

      return {
        ...prevState,
        attachments: updatedAttachments,
      };
    });
  };


  const handleDeleteFile = (fileToDelete) => () => {
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToDelete));
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newFiles = Array.from(event.target.files as FileList); // Explicitly cast to FileList

    const filePromises = newFiles.map((file) => {
      return new Promise<{ file_name: string; file: string }>(
        (resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            if (e.target?.result) {
              const fileData = {
                file_name: file.name, // No error because file is of type File
                file: (e.target.result as string).split(",")[1], // Extracting Base64 part
              };
              resolve(fileData);
            } else {
              reject(new Error("File reading error"));
            }
          };
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        }
      );
    });

    try {
      const fileDataArray = await Promise.all(filePromises);
      setCreateTaskInfo((prevState) => ({
        ...prevState,
        attachments: [...prevState.attachments, ...fileDataArray],
      }));
      const fileNames = fileDataArray.map((file) => file.file_name).join(", ");
      setHaveValues(fileNames);
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while uploading files. Please try again.");
    }
  };

  const stripHtmlTags = (html: string) => {
    const doc = new window.DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  };
  const formatTimeForAPI = (time: string) => {
    if (!time) return "";

    const today = new Date().toISOString().split("T")[0]; // Get today's date
    return `${today}T${time}:00+05:30`; // Convert "12:35" -> "2025-04-21T12:35:00+05:30"
  };

  // Convert ISO 8601 datetime to HH:MM format
  const formatTimeForUI = (isoTime: string): string => {
    const date = new Date(isoTime);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const saveHandler = async (e) => {
    setClicked(true);
    e.preventDefault();

    if (
      !createTaskInfo.subject ||
      !createTaskInfo.date ||
      !createTaskInfo.StartTime ||
      !createTaskInfo.EventDescription
    ) {
      toast.error("Fields are required");
      setErrorMessage(true);
      setClicked(false); // Re-enable the button if fields are missing
      return;
    }

    let formattedReminderTime = null;
    if (createTaskInfo.reminderTime) {
      const [hours, minutes, seconds] = createTaskInfo.reminderTime
        .split(":")
        .map(Number);

      const startTimeDate = new Date(createTaskInfo.StartTime);

      // Subtract reminder time from StartTime
      const reminderDateTime = new Date(
        startTimeDate.getTime() -
        (hours * 3600000 + minutes * 60000 + seconds * 1000)
      );

      // Convert to IST format (UTC+5:30)
      formattedReminderTime =
        new Date(reminderDateTime.getTime() + 5.5 * 3600000)
          .toISOString()
          .split(".")[0] + "+05:30";
    }

    const createTaskObj = {
      attachments: createTaskInfo?.attachments,
      created_by: selectedUser,
      created_for: parseInt(selectedUser),
      event_date: createTaskInfo?.date,
      event_description: stripHtmlTags(createTaskInfo?.EventDescription),
      lead: taskInfo?.id,
      reminder_time: formattedReminderTime, // Now properly formatted in IST
      start_time: createTaskInfo.StartTime,
      status: createTaskInfo?.status,
      team: Number(localStorage.getItem("teamId")),
      template_attachments: [],
      title: createTaskInfo?.subject,
      assigned_by: taskInfo?.assignee?.username,
      assignee: taskInfo?.assignee?.id,
    };

    try {
      const response = await createTask(createTaskObj);
      if (response?.data) {
        toast.success("Task added successfully");
        close();
      } else if ("data" in response?.error) {
        const errorData = response?.error.data as {
          status: string[];
          message: string[];
        };
        const errorMessage = errorData.message[0] || errorData.status[0];
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while saving the task.");
    } finally {
      setClicked(false); // Re-enable the button after the request finishes
    }
  };


  return (
    <div>
      <div style={{ display: "flex", width: "100%" }}>
        <span
          style={{
            width: "60%",
            display: "flex",
            justifyContent: "end",
            fontSize: "17px",
          }}
        >
          Create task
        </span>
        <span
          style={{
            flex: "1",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <i
            className="bi bi-x"
            style={{ fontSize: "20px", cursor: "pointer" }}
            onClick={close}
          ></i>
        </span>
      </div>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          gap: "10px",
          flexDirection: "column",
        }}
      >
        <div style={{ marginBottom: "5px" }}>
          <label style={{ fontSize: "15px" }} className="required">
            Subject
          </label>
          <input
            value={createTaskInfo.subject}
            className="form-control"
            onChange={(e) => {
              setCreateTaskInfo((prevState) => ({
                ...prevState,
                subject: e.target.value,
              }));
              setHaveValues(e.target.value);
            }}
          />
          {errorMessage && !createTaskInfo.subject ? (
            <p style={{ color: "red", margin: "0" }}>Field is required</p>
          ) : (
            ""
          )}
        </div>

        <div style={{ marginBottom: "5px" }}>
          <label style={{ fontSize: "15px" }}>Task owner</label>
          <select
            className="form-control"
            value={selectedUser}
            onChange={handleSelectChange}
            disabled={getUserRole === "agent"} // Optional: make dropdown readonly for agents
          >
            {getUserRole === "agent" ? (
              <option value={currentUser}>{currentUser}</option>
            ) : (
              users?.map((user) => (
                <option key={user?.id} value={user?.id || ""}>
                  {user?.username || ""}
                </option>
              ))
            )}
          </select>
        </div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div>
            <label style={{ fontSize: "15px" }} className="required">
              Date
            </label>
            <DatePicker
              format="DD/MM/YYYY" // UI format
              value={
                createTaskInfo.date
                  ? dayjs(createTaskInfo.date, "YYYY-MM-DD")
                  : null
              } // Convert stored date to UI format
              onChange={(newValue) => {
                setCreateTaskInfo((prevState) => ({
                  ...prevState,
                  date: newValue ? newValue.format("YYYY-MM-DD") : "", // Store in API format
                }));
              }}
              disablePast // This will disable all past dates
              slotProps={{
                textField: {
                  fullWidth: true,
                },
              }}
            />

            {errorMessage && !createTaskInfo.date && (
              <p style={{ color: "red", margin: "0" }}>Field is required</p>
            )}
          </div>
          <div style={{ marginTop: "10px" }}>
            <label style={{ fontSize: "15px" }} className="required">
              Time
            </label>
            <Autocomplete
              freeSolo
              options={timeSlots}
              value={
                createTaskInfo.StartTime
                  ? convertTo12Hour(formatTimeForUI(createTaskInfo.StartTime)) // Convert ISO time to 12-hour format
                  : ""
              }
              onChange={(_, newValue) => {
                setCreateTaskInfo((prevState) => ({
                  ...prevState,
                  StartTime: newValue
                    ? formatTimeForAPI(convertTo24Hour(newValue)) // Store as 24-hour format
                    : "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  onChange={(e) => {
                    setCreateTaskInfo((prevState) => ({
                      ...prevState,
                      StartTime: convertTo24Hour(e.target.value), // Convert typed input to 24h
                    }));
                  }}
                />
              )}
            />

            {errorMessage && !createTaskInfo.StartTime && (
              <p style={{ color: "red" }}>Field is required</p>
            )}
          </div>
        </LocalizationProvider>
        <div style={{ display: "flex", gap: "5px" }}>
          <input
            type="checkbox"
            onChange={() => setCheckboxSelected(!checkBoxSelected)}
          />
          <label>Remind at</label>
        </div>
        {checkBoxSelected && (
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexDirection: "column",
            }}
          >
            <div>
              <label style={{ fontSize: "15px" }}>Select reminder minute</label>
              <select
                className="form-control"
                value={createTaskInfo?.reminderTime}
                onChange={(e) => {
                  setCreateTaskInfo((prevState) => ({
                    ...prevState,
                    reminderTime: e.target.value,
                  }));
                  setHaveValues(e.target.value);
                }}
              >
                <option value="" disabled selected>
                  Select a reminder
                </option>
                {reminderTimeArry?.map((time, index) => (
                  <option value={time.id} key={time.id}>
                    {time?.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        <div>
          <label style={{ fontSize: "15px" }} className="required">
            Select status
          </label>
          <select
            className="form-control"
            value={createTaskInfo?.status}
            onChange={(e) => {
              setCreateTaskInfo((prevState) => ({
                ...prevState,
                status: e.target.value,
              }));
              setHaveValues(e.target.value);
            }}
          >
            <option selected disabled value="">
              Select status
            </option>
            {StatusArry?.map((status, index) => (
              <option value={status?.id} key={status?.id}>
                {status?.label}
              </option>
            ))}
          </select>
          {errorMessage && !createTaskInfo.status ? (
            <p style={{ color: "red", margin: "0" }}>Field is required</p>
          ) : (
            ""
          )}
        </div>

        <div>
          <label style={{ fontSize: "15px" }}>Description</label>
          {/* <div> */}
          <ReactQuill
            theme="snow"
            value={createTaskInfo?.EventDescription}
            onChange={(e) => {
              setCreateTaskInfo((prevState) => ({
                ...prevState,
                EventDescription: e,
              }));
              setHaveValues(e);
            }}
       
          />
        
          {errorMessage && !createTaskInfo?.EventDescription ? (
            <p style={{ color: "red", margin: "0" }}>Field is required</p>
          ) : (
            ""
          )}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          marginTop: "10px",
        }}
      >
        {createTaskInfo?.attachments.map((fileName, index) => (
          <div
            style={{
              display: "flex",
              gap: "10px",
              background: "#e3e0e0",
              borderRadius: "5px",
              padding: "5px",
            }}
          >
            <span>
              <i
                className="bi bi-x-circle"
                onClick={() => deleteImageHandler(index)}
                style={{ color: "black" }}
              ></i>
            </span>
            <span>{fileName?.file_name}</span>
          </div>
        ))}
      </div>

      <div className="d-flex justify-content-between align-items-center mt-5">
        <div className="d-flex">
          <label
            htmlFor="attachFileInput"
            className={`btn btn-active-light-primary btn-icon `}
            title="You can add attachments for the following file types: xls,pdf,csv,doc,jpg,png up to a maximum size of 15MB"
          >
            <i className="bi bi-paperclip align-self-center text-dark fs-2 mx-2 "></i>
            <input
              type="file"
              id="attachFileInput"
              className="d-none"
              multiple
              onChange={handleFileChange}
            />
          </label>
        </div>
      </div>
      {files.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
          {files.map((file, index) => (
            <Chip
              key={index}
              label={file.file_name}
              onDelete={handleDeleteFile(file)}
            />
          ))}
        </Box>
      )}

      <div
        style={{
          marginTop: "20px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "end", width: "100%" }}>
          <button
            className="btn btn-primary"
            onClick={saveHandler}
            disabled={clicked || !haveValues}
          >

            Save

          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateTask;